import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

const LandingPage = lazy(() => import('./pages/LandingPage'));
const CourseCatalog = lazy(() => import('./pages/CourseCatalog'));
const CoursePage = lazy(() => import('./pages/CoursePage'));
const LessonPage = lazy(() => import('./pages/LessonPage'));
const StudentDashboard = lazy(() => import('./pages/StudentDashboard'));
const ParentDashboard = lazy(() => import('./pages/ParentDashboard'));
const PricingPage = lazy(() => import('./pages/PricingPage'));
const AskSagePage = lazy(() => import('./pages/AskSagePage'));
const AchievementsPage = lazy(() => import('./pages/AchievementsPage'));

function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>Loading awesome stuff...</p>
    </div>
  );
}

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/courses" element={<CourseCatalog />} />
            <Route path="/course/:courseId" element={<CoursePage />} />
            <Route path="/course/:courseId/lesson/:lessonId" element={<LessonPage />} />
            <Route path="/dashboard" element={<StudentDashboard />} />
            <Route path="/parent" element={<ParentDashboard />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/ask-sage" element={<AskSagePage />} />
            <Route path="/achievements" element={<AchievementsPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
